<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        <el-button type="primary" size="large" @click="fnPopCreate()">添加</el-button>
      </div>
    </div>
    <div class="tuolele-main-box">
      <el-table :key="tableKey" :data="lists" border stripe>
        <el-table-column label="应用名称" prop="app_name" align="center" />
        <el-table-column label="操作" align="center">
          <template slot-scope="{row}">
            <el-button type="text" @click="fnEditClass(row)">编辑</el-button>
            <el-button type="text" @click="fnEditPayChannel(row.app_id)">渠道编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <div class="footer pagination-footer" style="text-align: center;">
      <el-pagination layout="prev, pager, next, slot, jumper" :current-page.sync="listQuery.p" prev-text="上一页" next-text="下一页" :total="total" :page-size="listQuery.limit" @current-change="fnGetAppList" />
    </div> -->

    <el-dialog title="应用配置" :visible.sync="bCreateReply" width="70%">
      <el-form :model="classForm" class="fn-clear">
        <el-form-item label="应用名称">
          <el-input v-model="classForm.appName" />
        </el-form-item>
      </el-form>
      <el-button type="primary" @click="fnSubmitCreate()">提交</el-button>
    </el-dialog>
  </div>

</template>
<script>

// import { validateRequire } from '@/utils/validate'
// import Tool from '@/assets/js/tool.js'

export default {
  name: 'ShopClassList',
  data() {
    return {
      lists: [],
      tableKey: 0,
      total: 0,
      bCreateReply: false,
      classForm: {
        appId: '',
        appName: ''
      }
    }
  },
  created() {
    this.fnGetAppList()
  },
  methods: {
    fnGetAppList: function() {
      this.bCreateReply = false
      this.$http.getAppList().then(res => {
        this.lists = res.data
      })
    },
    fnPopCreate() {
      this.classForm.class_id = ''
      this.classForm.name = ''
      this.bCreateReply = true
    },
    fnSubmitCreate: function() {
      if (!this.classForm.appName) {
        this.$message.error('请输入应用名称')
        return
      }
      if (this.classForm.appId) {
        this.$http.improveAppName(this.classForm).then(res => {
          this.classForm.appId = ''
          this.classForm.appName = ''
          this.fnGetAppList()
        })
      } else {
        this.$http.createApp(this.classForm).then(res => {
          this.classForm.appId = ''
          this.classForm.appName = ''
          this.fnGetAppList()
        })
      }
    },
    fnDeleteClass(class_id) {
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        showClose: false
      }).then(() => {
        this.$http.delShopClass({ class_id }).then(res => {
          this.fnGetAppList()
        })
      })
    },
    fnEditClass(cls) {
      this.classForm.appId = cls.app_id
      this.classForm.appName = cls.app_name
      this.bCreateReply = true
    },
    fnEditPayChannel(appId) {
      this.$router.push({
        path: 'paymentAppChannelSetting',
        query: { appId }
      })
    }

  }
}
</script>
<style lang="scss">
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
